export default __webpack_public_path__ + "static/image8-0a962671f35bbbd7f3e76caf1f8783d3.png";